var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0L8.61128 0.548581C10.1518 1.93125 12.2299 2.77799 14.5185 2.77799C14.555 2.77799 14.5914 2.7778 14.6276 2.77741L15.2795 2.76968L15.4832 3.35653C15.8266 4.3482 16.001 5.38499 16 6.42824C16 11.0085 12.6942 14.8551 8.22159 15.946L8 16L7.77841 15.946C3.30589 14.8551 0 11.0085 0 6.42824C0 5.35688 0.181224 4.32399 0.516833 3.35653L0.720493 2.76968L1.37235 2.77741C1.40861 2.7778 1.44508 2.77799 1.48145 2.77799C3.77006 2.77799 5.84815 1.93125 7.38881 0.548581L7.99989 0H8ZM2.03311 4.44906C1.86297 5.09653 1.77724 5.76117 1.77782 6.42824C1.77782 10.1453 4.40675 13.2825 8 14.2574C11.5932 13.2825 14.2223 10.1453 14.2223 6.42824C14.2223 5.74483 14.1336 5.08192 13.9669 4.44906C11.7122 4.33694 9.6472 3.54181 8 2.27899C6.35279 3.54181 4.28792 4.33694 2.03311 4.44906Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroicon);
export default __webpack_public_path__ + "static/media/heroicon.36cc37b2fe0d9f6f5c0f77cca490e8b4.svg";
export { ForwardRef as ReactComponent };